import { Service, inject } from '@angular/core'
import { GetPublicEventParticipationQuery, PublicEventParticipation } from '@seiri/shared/common'
import { ApiService } from '../api.service'

/** A sign-up's own page, opened from the link in its e-mail; `query.t` is that link's token. */
@Service()
export class PublicEventParticipationApiService {
  private readonly api = inject(ApiService)

  getEventParticipation(eventParticipationId: string, query: GetPublicEventParticipationQuery, init?: RequestInit) {
    const url = this.api.createURL(`event-participations/${eventParticipationId}`)
    url.search = this.api.toQueryParams(query)
    return this.api.fetchJson<PublicEventParticipation>(url, { ...init })
  }

  /** Refused with `eventParticipation.cancel.deadlinePassed` or `…notAllowed`; answers with the page as it now is. */
  cancelEventParticipation(eventParticipationId: string, query: GetPublicEventParticipationQuery, init?: RequestInit) {
    const url = this.api.createURL(`event-participations/${eventParticipationId}/cancel`)
    url.search = this.api.toQueryParams(query)
    return this.api.fetchJson<PublicEventParticipation>(url, { method: 'POST', ...init })
  }
}
